import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OtherToolsTrashCanComponent } from 'Src/ng2/school/school-tools/other-tools/other-tools-trash-can/other-tools-trash-can.component';
import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { PageHeaderModule } from '../../header/page-header/page-header.module';
import { NvMatTooltipModule } from '../../nv-mat-tooltip/nv-mat-tooltip.module';
import { FixedTableModule } from '../fixed-table/fixed-table.module';
import { ListContainerComponent } from './list-container.component';
import { StickyScrollDirective } from './sticky-scroll.directive';

@NgModule({
  imports: [
    CommonModule,
    FixedTableModule,
    FormsModule,
    ReactiveFormsModule,
    PageHeaderModule,
    NvDesignLibraryModule,
    NvMatTooltipModule,
    MatCheckboxModule,
    NvTooltipModule,
  ],
  declarations: [ListContainerComponent, StickyScrollDirective, OtherToolsTrashCanComponent],
  exports: [ListContainerComponent],
  providers: [],
  entryComponents: [ListContainerComponent, OtherToolsTrashCanComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListContainerModule {}
